import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import OptimizedImage from '@/components/ui/OptimizedImage';

interface ServiceCardProps {
  title: string;
  description: string;
  image: string;
  link: string;
  delay?: number;
  altText?: string;
}

const ServiceCard = ({ title, description, image, link, delay = 0, altText }: ServiceCardProps) => {
  const defaultAlt = `${title} at iFix Apple Care Patna Bihar - expert repair service`;
  
  return (
    <Link
      to={link}
      className="group block glow-card overflow-hidden opacity-0 animate-fade-in hover:scale-[1.02]"
      style={{ animationDelay: `${delay}ms`, animationFillMode: 'forwards' }}
    >
      <div className="aspect-[4/3] overflow-hidden">
        <OptimizedImage
          src={image}
          alt={altText || defaultAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
          {title}
        </h3>
        <p className="text-muted-foreground text-sm mb-4 line-clamp-2">
          {description}
        </p>
        <div className="flex items-center gap-2 text-primary font-medium text-sm">
          Learn more
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
